import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Clock, Phone, Mail, LogOut } from 'lucide-react';
import Header from './Header';
import Footer from './Footer';

const PendingApproval = ({ user, onLogout }) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      const API_URL = process.env.REACT_APP_BACKEND_URL;
      await fetch(`${API_URL}/api/auth/logout`, {
        method: 'POST',
        credentials: 'include',
      });
    } catch (error) {
      console.error('Logout error:', error);
    }
    
    localStorage.removeItem('user');
    localStorage.removeItem('isAuthenticated');
    
    if (onLogout) {
      onLogout();
    } else {
      navigate('/');
    }
  };

  return (
    <div className="min-h-screen bg-slate-50">
      <Header />
      
      <div className="pt-32 pb-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-2xl mx-auto text-center">
          <div className="bg-white rounded-2xl shadow-xl p-8 md:p-12">
            <div className="w-20 h-20 bg-yellow-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Clock className="text-yellow-600" size={40} />
            </div>
            
            <h1 className="text-3xl font-bold text-slate-900 mb-4">
              Account Pending Approval
            </h1>
            
            <p className="text-lg text-gray-600 mb-6">
              Thank you for signing up, <strong>{user?.name || 'there'}</strong>!
            </p>
            
            <div className="bg-slate-50 rounded-xl p-6 mb-8">
              <p className="text-gray-700">
                Your account is currently being reviewed by our team. 
                We'll send you an email at <strong>{user?.email}</strong> once your 
                access has been approved.
              </p>
            </div>
            
            <p className="text-gray-600 mb-8">
              This usually takes less than 24 hours. If you need immediate access, 
              please contact us directly.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center mb-8">
              <Button 
                className="bg-green-600 hover:bg-green-700"
                onClick={() => window.location.href = 'tel:+19493719948'}
              >
                <Phone className="mr-2" size={18} />
                Call (949) 371-9948
              </Button>
              <Button 
                variant="outline"
                onClick={() => window.location.href = 'mailto:info@bcs-us.com?subject=Customer Portal Access Request'}
              >
                <Mail className="mr-2" size={18} />
                Email Us
              </Button>
            </div>
            
            <div className="pt-6 border-t">
              <Button 
                variant="ghost" 
                className="text-gray-500"
                onClick={handleLogout}
              >
                <LogOut className="mr-2" size={16} />
                Sign out and return home
              </Button>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default PendingApproval;
